"use client";
import { useState } from "react";
import { Icon } from "@zapier/zinnia-icons";
import { Button, Tooltip } from "@zapier/design-system";
import {
  emitUserInteractionEvent,
  UserInteractionEventName,
} from "src/observability/tracking";
import { type Template } from "src/types";

type ShareButtonProps = {
  apiHostName?: string;
  template: Template;
};

export const ShareButton = ({ apiHostName, template }: ShareButtonProps) => {
  const [tooltipText, setTooltipText] = useState<string>("");

  return (
    <Tooltip content={tooltipText} isOpen={Boolean(tooltipText)}>
      <Button
        iconPosition="start"
        variant="secondary"
        onPress={() => {
          navigator.clipboard
            .writeText(
              `${apiHostName || window.location.origin}/templates/details/${template.slug}`,
            )
            .then(() => {
              emitUserInteractionEvent(
                UserInteractionEventName.templateShareButtonClicked,
                {
                  event_action: "click",
                  option_selected: template.slug,
                  custom_tracking_fields: {
                    template_id: template.id,
                  },
                },
              );
              setTooltipText("Link copied to clipboard");
              setTimeout(() => setTooltipText(""), 2000);
            })
            .catch((err) => {
              console.error("Failed to copy:", err);
              setTooltipText("Failed to copy");
              setTimeout(() => setTooltipText(""), 2000);
            });
        }}
      >
        <Icon name="personGroup" size={16} />
        Share
      </Button>
    </Tooltip>
  );
};
